// extracted by mini-css-extract-plugin
export default {"color":"custom-color_color__HAp9V","selected":"custom-color_selected__2ue6N","wrapper":"custom-color_wrapper__PBLtn"};